import { passwordStrength, passwordStrengthScoreThreshold } from 'client/PasswordManager/PasswordManagerConstants';

const getPasswordStrength = (score) => {
  let strength = passwordStrength.strong;

  if (score <= passwordStrengthScoreThreshold[passwordStrength.weak]) {
    strength = passwordStrength.weak;
  }
  if (score > passwordStrengthScoreThreshold[passwordStrength.weak]
    && score < passwordStrengthScoreThreshold[passwordStrength.strong]) {
    strength = passwordStrength.medium;
  }
  return strength;
};

export default {
  getPasswordStrength,
};
